var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafetyplus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0.21L59.909 0.21 59.909 69.314 0 69.314z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#72BF98",
    d: "M29.954 66.722c2.898-1.093 16.595-6.607 23.577-21.716 5.434-11.757 3.672-24.667 2.89-28.388L29.954 2.816 3.488 16.618c-.782 3.721-2.544 16.63 2.89 28.388C13.36 60.115 27.057 65.63 29.954 66.722"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .007)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F2F59",
    d: "M51.172 43.909c-5.706 12.348-16.134 17.933-21.218 20.013-5.083-2.08-15.51-7.665-21.217-20.013-4.825-10.442-3.55-21.784-2.924-25.579L29.954 5.74l24.142 12.59c.626 3.795 1.901 15.137-2.924 25.579m7.792-27.833c-.16-.76-.652-1.41-1.341-1.77L31.156.504c-.753-.392-1.65-.392-2.403 0L2.286 14.306c-.69.36-1.181 1.01-1.341 1.77-.346 1.643-3.196 16.447 3.073 30.014 6.882 14.891 19.79 21.085 25.02 23.057.295.111.606.167.916.167.311 0 .622-.056.918-.167 5.23-1.972 18.137-8.166 25.019-23.057 6.27-13.567 3.419-28.37 3.073-30.014",
    mask: "url(#prefix__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F2F59",
    d: "M40.6 30.776h-6.728v-6.677c0-.989-.804-1.793-1.793-1.793h-4.25c-.988 0-1.793.804-1.793 1.793v6.677H19.31c-.989 0-1.793.804-1.793 1.793v4.45c0 .99.804 1.794 1.793 1.794h6.726v6.625c0 .989.805 1.793 1.793 1.793h4.25c.989 0 1.793-.804 1.793-1.793v-6.625h6.727c.989 0 1.793-.805 1.793-1.793v-4.451c0-.989-.804-1.793-1.793-1.793"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyplus);
export default __webpack_public_path__ + "static/media/safetyplus.4fa7f6d7d56075ecbdd06bbb424f0031.svg";
export { ForwardRef as ReactComponent };